export default [
  {
    path: '/agenda',
    name: 'agenda',
    component: () => import('@/views/agenda/AgendaEmbed.vue'),
    meta: {
      pageTitle: 'Agenda',
      breadcrumb: [
        {
          text: 'Agenda',
          active: true,
        },
      ],
    },
  },
]
